module.exports = __webpack_public_path__ + "img/relais-md.4d1ad4af.svg";